import { env } from '@lusha-app/env';
const config = {
    api_url: env === 'staging' ? 'https://wh-staging.lusha.com' : 'https://wh.lusha.com',
};
export default config;
